
import ComparePortfoliosModal from '@/components/ui/modal/ComparePortfoliosModal.vue';
export default {
  name: 'ComparePortfoliosModalWrapper',
  components: { ComparePortfoliosModal },
  methods: {},
};
